import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import axios from 'axios';


function Testimonials({ tilte, tagline }) {

  const [testiContent, setTestiContent] = useState([]);
  const getTesti = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}api/get-testimonials`);
      setTestiContent(res.data.data)
    } catch (err) {
      console.log('Fetching Testimonial Content', err)
    }
  }

  useEffect(() => {
    getTesti();
  }, [])

  return (
    <div className="bg-black pt-20 pb-20">
      <div className="container mx-auto px-4">
        <div className="testimonials">
          <h2 className="font-syne text-7xl text-center font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent max-w-[800px] mx-auto">
            {tilte}
          </h2>
          <p className="font-outfit text-center text-white pt-6 max-w-[800px] mx-auto">
            {tagline}
          </p>

          <div className="mt-16 relative">
            <Swiper
              modules={[Navigation]}
              navigation
              slidesPerView={1}
              loop
              className="testimonial-swiper"
            >
              {testiContent.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="flex bg-[#0d0d0d] border border-[#43aad6] rounded-xl p-6 md:flex-row flex-col items-center max-w-5xl mx-auto gap-10">
                    <img
                      src={`${process.env.REACT_APP_SITE_IMAGES}${item.image}`}
                      alt={item.name}
                      className="w-[200px] h-[200px] object-cover rounded-lg"
                    />
                    <div className="text-white">
                      <p className="font-outfit text-lg leading-relaxed mb-4">
                        “{item.comments}”
                      </p>
                      <h3 className="text-[#43aad6] font-syns font-bold text-xl font-syne">
                        {item.name}
                      </h3>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <style>{`
              .swiper-button-next,
              .swiper-button-prev {
                background: white;
                color: black;
                border-radius: 9999px;
                width: 40px;
                height: 40px;
              }

              .swiper-button-next::after,
              .swiper-button-prev::after {
                font-size: 20px;
              }

              .swiper-button-prev {
                left: 5px;
              }

              .swiper-button-next {
                right: 5px;
              }

              @media (max-width: 768px) {
                .swiper-button-next,
                .swiper-button-prev {
                  display: none;
                }
              }
            `}</style>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Testimonials;
